import Button from '@primitives/Button';
import cx from 'classnames';
import FileIcon from '@cp/assets/images/icons/FileIcon';
import DownloadIcon from '@cp/assets/images/icons/DownloadIcon';
import { Control, useController } from 'react-hook-form';
import { AgentFormValues } from '@cp/pages/AllAgents/AgentForm/interfaces/types';
import { GenericObject } from '@cp/src/types/CommonConstans';
import { getFileDownload } from '@cp/utils/commonUtils';
import CrossIcon from '@cp/assets/icons/CrossIcon';
import { Typography } from '@navi/web-ui/lib/primitives';
import { PAN_VERIFICATION_STATUS_MAP } from '../../utils/AgentFormUtils';

type AgentFormDownloadPanProps = {
  name: keyof AgentFormValues;
  containerClassName?: string;
  control: Control<AgentFormValues, any>;
  rules?: GenericObject;
  isEditDisable: boolean;
  inputLabel: string;
  panVerificationStatus: string;
  isRequired?: boolean;
};

const AgentFormDownloadPan = (props: AgentFormDownloadPanProps) => {
  const {
    name,
    containerClassName,
    control,
    rules,
    isEditDisable = false,
    inputLabel = '',
    panVerificationStatus,
    isRequired = false
  } = props;
  const { validationMessage, icon } = PAN_VERIFICATION_STATUS_MAP[panVerificationStatus] || {};
  const { field } = useController({
    name,
    control,
    rules
  });
  return (
    <>
      <div className="text-[--grayscale-2] text-[14px] ml-[14px] mt-[16px]">
        {inputLabel}
        {isRequired && <span className="text-[--red-base] ml-1">*</span>}
      </div>
      <div
        className={cx(
          'flex items-center justify-between text-gray-600 mt-3.5 rounded-lg border border-solid border-[--blue-border] bg-[var(--blue-light-bg)] h-[40px] ml-3 gap-2 p-2',
          containerClassName
        )}
      >
        <div className=" flex gap-2 items-center">
          <div>
            <FileIcon width={20} height={20} />
          </div>
          <div className="max-w-[200px] text-ellipsis  overflow-hidden">Agent {inputLabel}.jpg</div>
        </div>
        <div className="controls flex items-center gap-1 mr-2">
          {!isEditDisable ? (
            <Button
              variant="text"
              onClick={e => {
                e.preventDefault();
                field.onChange(null);
              }}
            >
              <CrossIcon height={16} width={16} fillColor={'var(--blue-base)'} />
            </Button>
          ) : (
            <Button
              variant="text"
              onClick={e => {
                e.preventDefault();
                // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                getFileDownload(field?.value?.userDocument?.uri, true);
              }}
            >
              <DownloadIcon height={20} width={20} />
            </Button>
          )}
        </div>
      </div>
      <div className="flex gap-1 ml-[14px] items-center mt-[8px]">
        {icon}
        <Typography className="text-[var(--grayscale-3)]" variant="p4">
          {validationMessage}
        </Typography>
      </div>
    </>
  );
};

export default AgentFormDownloadPan;
